import * as React from 'react';
import { UtilityText } from '@leagueplatform/genesis-core';
import type { ConfigEntityDetail, EntityDetail } from '@web-config-app/core';
import { useIntl } from '@leagueplatform/locales';
import { LinkableCell, TableCell } from '../table-pieces.component';

export type LinkedNameCellProps = {
  item: ConfigEntityDetail | EntityDetail;
  linkTo?: string;
  getItemName: (data: ConfigEntityDetail | EntityDetail) => string | undefined;
};

export const LinkedNameCell: React.FC<LinkedNameCellProps> = ({
  item,
  linkTo,
  getItemName,
}) => {
  const { formatMessage } = useIntl();
  return (
    <LinkableCell as="th" scope="row" linkTo={linkTo}>
      <UtilityText>
        {getItemName(item) || formatMessage({ id: 'UNTITLED' })}
      </UtilityText>
    </LinkableCell>
  );
};

export type SelectableNameCellProps = {
  item: ConfigEntityDetail | EntityDetail;
  getItemName: (data: ConfigEntityDetail | EntityDetail) => string | undefined;
};

export const SelectableNameCell: React.FC<SelectableNameCellProps> = ({
  item,
  getItemName,
}) => {
  const { formatMessage } = useIntl();
  return (
    <TableCell
      as="th"
      scope="row"
      css={{
        position: 'relative',
        paddingY: '$threeQuarters',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      <UtilityText
        as="label"
        htmlFor={`entity-${item.id}`}
        css={{
          '&:after': {
            content: '',
            display: 'block',
            position: 'absolute',
            width: '87vw',
            inset: 0,
            cursor: 'pointer',
          },
        }}
      >
        {getItemName(item) || formatMessage({ id: 'UNTITLED' })}
      </UtilityText>
    </TableCell>
  );
};
